import _ from 'underscore';
import { Component } from 'react';
import { ThemeProvider, OverlayProvider } from '@workramp/ui';
import WRModalsAlert from './wr-modals-alert';
import WRModalsConfirm from './wr-modals-confirm';
import WRModalsPrompt from './wr-modals-prompt';

class WRModalsContainer extends Component {
  state = {
    alertShow: false,
    alertText: null,
    alertCallback: null,

    confirmShow: false,
    confirmText: null,
    confirmCallback: null,
    saveButtonTitle: null,

    promptShow: false,
    promptText: null,
    promptPlaceholder: null,
    promptValue: null,
    promptCallback: null,
    promptOptions: null,

    customShow: false,
    customComponent: null,
    customProps: null,
    customCallback: null,
    customCloseCallback: null,
  };

  componentDidMount() {
    if (WRModals.isLoaded) {
      console.error('More than one WRModalsContainer in app.');
      return;
    }

    const me = this;
    WRModals.alert = function (text, alertCallback = null, alertTextRenderer = null, options = {}) {
      me.setState({ alertShow: true, alertText: text, alertCallback, alertTextRenderer, newUi: options.newUi });
    };
    WRModals.confirm = function (text, callback, options = {}) {
      me.setState({
        confirmShow: true,
        confirmText: text,
        confirmCallback: callback,
        saveButtonTitle: options.saveButtonTitle,
        alertTextRenderer: options.alertTextRenderer,
        newUi: options.newUi,
        isDangerConfirm: options.isDangerConfirm,
      });
    };
    WRModals.prompt = function (text, placeholder, value, callback, options) {
      me.setState({
        promptShow: true,
        promptText: text,
        promptPlaceholder: placeholder,
        promptValue: value,
        promptCallback: callback,
        promptOptions: options,
      });
    };
    WRModals.custom = function (component, props, callback, closeCallback) {
      // Need to render the component in the tree before showing it
      me.setState(
        {
          customShow: false,
          customComponent: component,
          customProps: props,
          customCallback: callback,
          customCloseCallback: closeCallback,
        },
        () => {
          me.setState({ customShow: true });
        },
      );
    };

    WRModals.setCustomProps = function (newCustomProps) {
      me.setState({
        customProps: newCustomProps,
      });
    };

    WRModals.isLoaded = true;
  }

  render() {
    const CustomModal = this.state.customComponent;

    return (
      <ThemeProvider>
        <OverlayProvider>
          <div>
            <WRModalsAlert
              show={this.state.alertShow}
              text={this.state.alertText}
              newUi={this.state.newUi}
              alertTextRenderer={this.state.alertTextRenderer}
              onClose={this.onAlertClose}
            />
            <WRModalsConfirm
              show={this.state.confirmShow}
              text={this.state.confirmText}
              onSave={this.state.confirmCallback}
              onClose={this.onConfirmClose}
              saveButtonTitle={this.state.saveButtonTitle}
              alertTextRenderer={this.state.alertTextRenderer}
              newUi={this.state.newUi}
              isDangerConfirm={this.state.isDangerConfirm}
            />
            <WRModalsPrompt
              show={this.state.promptShow}
              text={this.state.promptText}
              placeholder={this.state.promptPlaceholder}
              value={this.state.promptValue}
              onSave={this.state.promptCallback}
              onClose={this.onPromptClose}
              options={this.state.promptOptions}
            />
            {CustomModal ? (
              <CustomModal
                {...this.state.customProps}
                show={this.state.customShow}
                onSave={this.onCustomSave}
                onClose={this.onCustomClose}
              />
            ) : null}
          </div>
        </OverlayProvider>
      </ThemeProvider>
    );
  }

  onAlertClose = () => {
    this.setState(
      {
        alertShow: false,
        alertText: null,
        alertTextRenderer: null,
      },
      () => {
        if (_.isFunction(this.state.alertCallback)) {
          this.state.alertCallback();
        }

        this.setState({
          alertCallback: null,
        });
      },
    );
  };

  onConfirmClose = () => {
    this.setState({
      confirmShow: false,
      confirmText: null,
      confirmCallback: null,
    });
  };

  onPromptClose = () => {
    this.setState({
      promptShow: false,
      promptText: null,
      promptPlaceholder: null,
      promptValue: null,
      promptCallback: null,
      promptOptions: null,
    });
  };

  onCustomSave = (...args) => {
    this.state.customCallback(...args);
    this.onCustomClose();
  };

  onCustomClose = () => {
    this.setState(
      {
        customShow: false,
      },
      () => {
        if (typeof this.state.customCloseCallback === 'function') {
          this.state.customCloseCallback();
        }
        this.setState({
          customComponent: null,
          customProps: null,
          customCallback: null,
          customCloseCallback: null,
        });
      },
    );
  };
}

const _WRModalsNotLoaded = function () {
  console.error('WRModals not loaded yet.');
};

export const WRModals = {
  isLoaded: false,
  /** @deprecated prefer `import { AlertModal } from '~/features/common/components/AlertModal';` */
  alert: _WRModalsNotLoaded,
  /** @deprecated prefer `import { ConfirmModal } from '~/features/common/components/ConfirmModal';` */
  confirm: _WRModalsNotLoaded,
  prompt: _WRModalsNotLoaded,
  custom: _WRModalsNotLoaded,
};

export default WRModalsContainer;
